module.exports = __webpack_public_path__ + "img/letter-i.b42dec5c.svg";